"use client";

// This is a client side component that exists to start Post Hog session recording if the user has signed up in the last 5 minutes

import { useSession } from "next-auth/react";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";

export default function PHSessionReplay(): null {
  const posthog = usePostHog();
  const { data: session } = useSession();
  const sessionRecordingStarted = useRef(false);

  useEffect(() => {
    if (sessionRecordingStarted.current) return;
    posthog.startSessionRecording();
    sessionRecordingStarted.current = true;
  }, [posthog, session]);

  return null;
}
